import { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Components/Applications/ECommerce/Common/FilterComponent";
import { useSelector } from "react-redux";
import SvgIcon from "../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import {
  deleteDiscount,
  setLoading,
} from "../../ReduxToolkit/Reducers/AppReducer";

export default function ListTable() {
  const categoryColumns = [
    {
      name: "Code",
      selector: (row) => row.code,
      sortable: true,
      width: "15%",
      cell: (row) => (
        <p className="d-flex align-items-center gap-2 m-0">
          {row.code}
          <span
            className={`badge ${row.is_valid ? "bg-success" : "bg-danger"}`}
            style={{ fontSize: "0.75rem" }}
          >
            {row.is_valid ? "Valid" : "Invalid"}
          </span>
        </p>
      ),
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
      cell: (row) => <p>{row.amount}</p>,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
      cell: (row) => <p>{row.description}</p>,
      width: "300px !important",
    },
    {
      name: "Discount",
      selector: (row) => row.discount_type,
      sortable: true,
      cell: (row) => (
        <p>{row.discount_type === "fixed_cart" ? "Fixed Cart " : "Percent"}</p>
      ),
    },
    {
      name: "Usage",
      selector: (row) => row.usage_count,
      sortable: true,
      cell: (row) => (
        <p className="m-0">
          {row.usage_limit && row.usage_limit > 0
            ? `${row.usage_count}/${row.usage_limit}`
            : `${row.usage_count}/Unlimited`}
        </p>
      ),
    },
    {
      name: "Expiry Date",
      selector: (row) => row.date_expires,
      sortable: true,
      cell: (row) => <p>{row.date_expires}</p>,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="product-action">
          <SvgIcon iconId="trash1" onClick={() => handleDelete(row)} />
        </div>
      ),
      sortable: false,
    },
  ];
  const dispatch = useDispatch();
  const [filterText, setFilterText] = useState("");
  const { discounts } = useSelector((state) => state.app);
  const filteredItems = discounts.filter((item) => {
    return Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
    );
  });

  const handleDelete = async (item) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--theme-red)",
      cancelButtonColor: "var(--theme-blue)",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        dispatch(setLoading(true));
        const data = { data: { coupon: item.code } };
        dispatch(deleteDiscount(data));
        toast.success("Discount Deleted");
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(setLoading(false));
        console.log(error);
        toast.error("Error Deleting Discount");
      }
    }
  };
  return (
    <div className="list-product list-category">
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        filterText={filterText}
      />
      <DataTable
        className="custom-scrollbar"
        data={filteredItems}
        columns={categoryColumns}
        pagination
      />
    </div>
  );
}
